import React from 'react';
import './Hero.css';
import servicesImage from '../images/services.png';
import { trackCTA } from '../services/trackingService';

const Hero = () => {
    const handleScrollTo = (targetId) => {
        const element = document.getElementById(targetId);
        if (!element) return;
        const header = document.querySelector('.header');
        const offset = (header ? header.offsetHeight : 80) + 12; // espace supplémentaire
        const top = element.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
        // Après l'animation de scroll, placer le focus pour accessibilité
        setTimeout(() => {
            if (element && typeof element.focus === 'function') {
                element.focus({ preventScroll: true });
            }
        }, 450);
    };

    return (
        <section className="hero" aria-labelledby="site-hero-heading">
            <div className="hero__bg" style={{ backgroundImage: `url(${servicesImage})` }} />
            <div className="hero__overlay" />
            <div className="hero__inner container">
                <div className="hero__content" role="presentation">
                    <h1 id="site-hero-heading" className="hero__title">
                        <span className="hero__brand">New<span className="accent">School</span></span>{' '}<span className="hero__subtitle">Centre de formation linguistique</span>
                    </h1>
                    <p className="hero__lead lead">Formations langues – certification – financement CPF, OPCO & Pôle Emploi.</p>
                    <ul className="hero__highlights" aria-label="Points forts">
                        <li><i className="fa fa-check" aria-hidden="true"></i><span>Présentiel & distanciel</span></li>
                        <li><i className="fa fa-check" aria-hidden="true"></i><span>Prise en charge CPF / OPCO / Pôle Emploi</span></li>
                        <li><i className="fa fa-check" aria-hidden="true"></i><span>Organisme certifié Qualiopi</span></li>
                        <li><i className="fa fa-check" aria-hidden="true"></i><span>Certification LILATE – normes européennes</span></li>
                        <li><i className="fa fa-check" aria-hidden="true"></i><span>Certification LEVELTEL – CECRL</span></li>
                        <li><i className="fa fa-check" aria-hidden="true"></i><span>Devis gratuit sous 24h</span></li>
                    </ul>
                    <div className="hero__actions">
                        <a
                            href="#Formationsprofessionnelles"
                            className="btn btn--accent"
                            onClick={(e) => { e.preventDefault(); trackCTA('hero_en_savoir_plus', 'Hero', 'scroll_to_catalogues'); handleScrollTo('Formationsprofessionnelles'); }}
                        >
                            En savoir plus
                        </a>
                        <a
                            href="#nouscontacter"
                            className="btn btn--outline-light"
                            onClick={(e) => { e.preventDefault(); trackCTA('hero_devis_en_ligne', 'Hero', 'scroll_to_contact'); handleScrollTo('nouscontacter'); }}
                        >
                            Devis en ligne
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
